// Satu sumber pemetaan role -> halaman utama, dipakai App.js (ProtectedRoute, redirect kalau
// role tidak cocok) DAN Login.jsx (redirect setelah login berhasil) — supaya dua tempat itu
// tidak bisa diam-diam beda pemetaan. File terpisah (bukan taruh di App.js) sengaja untuk
// menghindari circular import (App.js sendiri me-import Login.jsx).
//
// TIDAK ADA role "developer"/"designer" terpisah — developer/designer login sebagai "karyawan"
// biasa (lihat menu "Pendapatan" di dashboard karyawan, delegasi lewat Developer.employee_id/
// Designer.employee_id di backend), bukan akun/portal sendiri.
//
// Menerima objek user LENGKAP (bukan cuma string role) — dibutuhkan supaya akun client yang
// tertaut ke Group Client (user.group_id, "Kepala Group") bisa diarahkan langsung ke menu
// "Project Group" (/client/group), bukan "Project Anda" (/client), begitu login/refresh. Untuk
// kompatibilitas mundur tetap menerima bare string role (dianggap tidak punya group_id/
// client_id apa pun, jatuh ke default lama).
export function roleHomePath(user) {
  const role = typeof user === "string" ? user : user?.role;
  if (role === "admin") return "/admin";
  if (role === "client") {
    // Kepala Group (tertaut Group Client) -> langsung ke "Project Group", bukan "Project Anda"
    // — berlaku juga untuk akun yang tertaut KEDUANYA sekaligus (§15.13), karena statusnya
    // tetap Kepala Group. Akun yang cuma tertaut Client perorangan tetap ke /client seperti biasa.
    if (typeof user === "object" && user?.group_id) return "/client/group";
    return "/client";
  }
  if (role === "vendor") return "/vendor";
  return "/karyawan";
}
